import injectionHelpers from '@carwow/injection-rules-helpers';

import config from '@carwow/injection-default-config';

const shouldInject = (options) => {
  const {
    amp,
    currentRuleInjectedComponentCount: teadsCount,
    currentRuleComponentTypeWordCount: currentWordCount,
    currentType,
    nextType,
    props,
  } = options;

  return amp
  && injectionHelpers.isBetweenTwoTextBlocks({ currentType, nextType })
  && injectionHelpers.isRightNumberOfWordsForTeads({ currentWordCount, teadsCount, props });
};

const teads = {
  id: 'tead-ads',
  componentType: 'teads',
  condition: (options) => shouldInject(options),
  component: (localConfig = {}) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'tead-ads',
    props: {},
    defaultConfig: config.getTeadsAdConfig(),
  }),
  resetCurrentItemTypeCurrentCounter: false,
};

export default [
  teads,
];
